'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@heroui/react';
import Link from 'next/link';
import { toast } from 'sonner';
import { FAQS_LIST_SECTION_ID } from '@/app/(public)/(landing-pages)/faqs/shared/constants/section-ids';
import { LightClubeLogo } from '@/components/svgs/club-pormade-logo';
import InstagramIcon from '@/components/svgs/icons/instagram-icon';
import LinkedinIcon from '@/components/svgs/icons/linkedin-icon';
import PinterestIcon from '@/components/svgs/icons/pinterest-icon';
import TikTokIcon from '@/components/svgs/icons/tiktok-icon';
import YoutubeIcon from '@/components/svgs/youtube-icon';
import InView from '@/components/ui/in-view';
import { APP_ROUTES } from '@/shared/constants/app-routes';
export default function LandingPageFooter() {
  const $ = _c(35);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      hidden: t0,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    t2 = {
      margin: "0px 0px -100px 0px",
      once: true
    };
    t3 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex w-full flex-col items-start justify-between gap-4 sm:gap-8 sm:flex-row sm:items-center md:w-auto md:flex-col md:justify-start"><div className="flex w-full select-none items-start gap-2"><LightClubeLogo width={200} className="sm:flex hidden" /><LightClubeLogo width={150} className="sm:hidden flex" /></div><button className="cursor-pointer font-dm_sans text-lg font-normal text-default-600 sm:text-2xl" type="button" onClick={_temp}>clube@pormade.com.br</button></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="sm:text-2xl text-xl font-bold">Ajuda</h1>;
    t6 = <Link href="#" target="_blank" className="text-default-600 sm:text-lg text-base">Termos de uso</Link>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="sm:w-auto w-full flex flex-col font-normal  items-start gap-4 sm:items-center md:items-end">{t5}{t6}<Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.LINKEDIN || "#"} target="_blank" className="text-default-600 sm:text-lg text-base">Trabalhe conosco</Link><Link href={`#${FAQS_LIST_SECTION_ID}`} className="text-default-600 sm:text-lg text-base">Perguntas frequentes</Link></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h1 className="sm:text-2xl text-xl font-bold">Empresa</h1>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.BLOG || "#"} target="_blank" className="text-default-600 sm:text-lg text-base">Blog</Link>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.MAIN_WEB_SITE || "#"} target="_blank" className="text-default-600 sm:text-lg text-base">Nosso site</Link>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="sm:w-auto w-full flex flex-col font-normal items-start gap-4 sm:items-center md:items-end">{t8}{t9}{t10}<Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.INSTALLATION_MASTERS || "#"} target="_blank" className="text-default-600 sm:text-lg text-base">Mestres da instalação</Link></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex w-full flex-col items-start gap-12 md:flex-row md:gap-4">{t4}<div className="flex w-full flex-wrap items-end justify-between gap-4 sm:gap-8 font-dm_sans font-bold md:justify-end lg:gap-12">{t7}{t11}<div className="sm:w-auto w-full flex flex-col font-normal  items-start gap-4 sm:items-center md:items-end"><h1 className="sm:text-2xl text-xl font-bold">Contatos</h1><Link href="#" target="_blank" className="text-default-600 sm:text-lg text-base">0800 642 3521</Link><Link href="#" target="_blank" className="text-default-600 sm:text-lg text-base">(42) 99117-2501</Link><button className="cursor-pointer font-dm_sans text-lg font-normal text-default-600" type="button" onClick={_temp2}>sac@pormade.com.br</button></div></div></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      hidden: {
        opacity: 0,
        filter: "blur(4px)"
      },
      visible: {
        opacity: 1,
        filter: "blur(0px)"
      }
    };
    t14 = {
      margin: "0px 0px -50px 0px",
      once: true
    };
    t15 = {
      duration: 0.4,
      ease: "easeInOut"
    };
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <InView variants={t13} viewOptions={t14} transition={t15}><Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.YOUTUBE || "#"} target="_blank"><YoutubeIcon /></Link></InView>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  let t18;
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      hidden: {
        opacity: 0,
        filter: "blur(4px)"
      },
      visible: {
        opacity: 1,
        filter: "blur(0px)"
      }
    };
    t18 = {
      margin: "0px 0px -50px 0px",
      once: true
    };
    t19 = {
      duration: 0.4,
      ease: "easeInOut",
      delay: 0.2
    };
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <InView variants={t17} viewOptions={t18} transition={t19}><Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.INSTAGRAM || "#"} target="_blank"><InstagramIcon /></Link></InView>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  let t22;
  let t23;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      hidden: {
        opacity: 0,
        filter: "blur(4px)"
      },
      visible: {
        opacity: 1,
        filter: "blur(0px)"
      }
    };
    t22 = {
      margin: "0px 0px -50px 0px",
      once: true
    };
    t23 = {
      duration: 0.4,
      ease: "easeInOut",
      delay: 0.4
    };
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
  } else {
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <InView variants={t21} viewOptions={t22} transition={t23}><Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.TIKTOK || "#"} target="_blank"><TikTokIcon /></Link></InView>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  let t26;
  let t27;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      hidden: {
        opacity: 0,
        filter: "blur(4px)"
      },
      visible: {
        opacity: 1,
        filter: "blur(0px)"
      }
    };
    t26 = {
      margin: "0px 0px -50px 0px",
      once: true
    };
    t27 = {
      duration: 0.4,
      ease: "easeInOut",
      delay: 0.6
    };
    $[25] = t25;
    $[26] = t26;
    $[27] = t27;
  } else {
    t25 = $[25];
    t26 = $[26];
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <InView variants={t25} viewOptions={t26} transition={t27}><Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.PINTEREST || "#"} target="_blank"><PinterestIcon /></Link></InView>;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  let t30;
  let t31;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      hidden: {
        opacity: 0,
        filter: "blur(4px)"
      },
      visible: {
        opacity: 1,
        filter: "blur(0px)"
      }
    };
    t30 = {
      margin: "0px 0px -50px 0px",
      once: true
    };
    t31 = {
      duration: 0.4,
      ease: "easeIn",
      delay: 0.8
    };
    $[29] = t29;
    $[30] = t30;
    $[31] = t31;
  } else {
    t29 = $[29];
    t30 = $[30];
    t31 = $[31];
  }
  let t32;
  let t33;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="flex w-full items-center gap-4">{t16}{t20}{t24}{t28}<InView variants={t29} viewOptions={t30} transition={t31}><Link href={APP_ROUTES.EXTERNAL.ENTERPRISE.LINKEDIN || "#"} target="_blank"><LinkedinIcon /></Link></InView></div>;
    t33 = <Divider className="bg-secondary h-0.5 sm:max-w-[90%] mx-auto" />;
    $[32] = t32;
    $[33] = t33;
  } else {
    t32 = $[32];
    t33 = $[33];
  }
  let t34;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <footer className="relative flex w-full flex-col"><InView variants={t1} viewOptions={t2} transition={t3}><div className="z-10 flex h-full flex-col gap-12 p-12 text-foreground lg:p-16">{t12}{t32}{t33}<div className="flex w-full  flex-col items-center py-4"><p className="select-none text-center font-dm_sans text-base font-normal">{`© ${new Date().getFullYear()} Pormade Portas. Todos os direitos reservados`}</p></div></div></InView></footer>;
    $[34] = t34;
  } else {
    t34 = $[34];
  }
  return t34;
}
function _temp2() {
  navigator.clipboard.writeText("sac@pormade.com.br");
  toast.info("Copiado!");
}
function _temp() {
  navigator.clipboard.writeText("clube@pormade.com.br");
  toast.info("Copiado!");
}